import React from 'react'
import Navbar from 'scenes/navbar'
const NormalLayout = () => {
  return (
    <Navbar/>
  )
}

export default NormalLayout